import type { AuthState } from '@ppl/auth';
import { authReducer } from '@ppl/auth';
import { combineReducers } from '@ppl/store';
import type { RouterState } from './router/router.reducer';
import { routerReducer } from './router/router.reducer';
import type { LoginState } from '../../modules/login/store/login.reducer';
import { loginReducer } from '../../modules/login/store/login.reducer';


const coreInternalReducer = combineReducers<CoreState>({
  auth: authReducer,
  router: routerReducer,
  login: loginReducer
});

export const coreReducer = (state: CoreState, action: any) => {
  return coreInternalReducer(state, action);
};

export interface CoreState {
  auth: AuthState;
  router: RouterState;
  login: LoginState;
}
